// Module
var code = "<span ng-style=\"formatter.styles\">{{ formatter.postFormat}}</span>";
// Exports
module.exports = code;